import _ from 'lodash'

import {
  RESET,
  FETCH,
  FETCH_FAIL,
  FETCH_SUCCESS,
  LOGIN,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGOUT,
  LOGOUT_FAIL,
  LOGOUT_SUCCESS,
  FETCH_ORGANIZATION_SCHEDULE_SUCCESS
} from 'react-redux/actions/user'

import {
  FETCH_SUCCESS as FETCH_LANGUAGE_SUCCESS
} from 'react-redux/actions/language'

const initialState = {
  loggingIn: false,
  loggingOut: false,
  fetching: false,
  error: false,
  errorText: "",
  email: null,
  name: null,
  surname: null,
  timeCreated: null,
  timeModified: null,
  lastPasswordChange: null,
  organizations: [],
  loggedIn: false,
  language: 'de',
  organizationSchedule: false
}

/* TODO: Set isSuperUser flag explicitly */
export default (state = initialState, action) => {
  switch (action.type) {
    case RESET: {
      return Object.assign(_.cloneDeep(initialState))
    }
    case FETCH: {
      return Object.assign(
        {},
        state,
        action.payload,
        {
          fetching: true
        }
      )
    }
    case FETCH_FAIL: {
      return Object.assign(
        {},
        state,
        {
          fetching: false
        }
      )
    }
    case FETCH_SUCCESS: {
      return Object.assign(
        {},
        state,
        action.payload,
        {
          fetching: false
        }
      )
    }
    case LOGIN: {
      return Object.assign(
        {},
        state,
        {
          loggingIn: true
        }
      )
    }
    case LOGIN_FAIL: {
      return Object.assign(
        {},
        state,
        {
          loggingIn: false,
          error: action.payload.response.error,
          loggedIn: false
        }
      )
    }
    case LOGIN_SUCCESS: {
      return Object.assign(
        {},
        state,
        {
          loggingIn: false,
          error: null,
          loggedIn: true
        }
      )
    }
    case LOGOUT: {
      return Object.assign(
        {},
        state,
        {
          loggingOut: true
        }
      )
    }
    case LOGOUT_FAIL: {
      return Object.assign(
        {},
        state,
        {
          loggingOut: false,
          loggedIn: false
        }
      )
    }
    case LOGOUT_SUCCESS: {
      return Object.assign(
        {},
        state,
        {
          loggingOut: false,
          loggedIn: false
        }
      )
    }
    case FETCH_ORGANIZATION_SCHEDULE_SUCCESS:{
      //console.log(action.payload)
      return Object.assign(
        {},
        state,
        {
          organizationSchedule: action.payload.schedule || state.organizationSchedule
        }
      )

    }
    case FETCH_LANGUAGE_SUCCESS: {
      return Object.assign(
        {},
        state,
        {
          language: action.payload || state.language
        }
      )
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/react-redux/reducers/user.js